import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export class CustomButton extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    value: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    manuallyDisabled: PropTypes.bool,
    dataCy: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      hoverButton: false
    };
  }

  render() {
    const { id, className, disabled, value, onClick, manuallyDisabled, dataCy } = this.props;
    return (
      <button
        id={id}
        onClick={onClick}
        type="submit"
        className={`button ${className}`}
        disabled={disabled || manuallyDisabled}
        data-cy={dataCy}
      >
        {value}
      </button>
    );
  }
}

function mapStateToProps(state) {
  return {
    disabled: state.components.fetching
  };
}

export default connect(mapStateToProps)(CustomButton);
